export default "__VITE_ASSET__Wi74rxXt__"